export default class Logger {
  constructor(private readonly debug: boolean) {}

  public log(message: string, payload?: any): void {
    if (!this.debug) {
      return
    }

    console.log(message, payload)
  }
}
